module.exports = __webpack_public_path__ + "static/media/E602.f316e0ed.png";